export default {
  Default: require('./default').default,
  Mobile: require('./mobile').default,
  MobileFirst: require('./mobile_first').default,
  MessageGuide: require('./message_guide').default,
  Payment: require('./payment').default,
  Personal: require('./personal').default,
  Summary: require('./summary').default,
  Waiver: require('./waiver').default,
};
